import { IBaseIconProps } from "./IBaseIconProps";

export const UsersIcon = ({
  color = "#000",
  backgroundColor,
}: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
    >
      <path d="m45.832 54.168h8.3359c4.418 0 8.6602 1.7539 11.785 4.8789s4.8789 7.3672 4.8789 11.785v8.3359c0 1.1055-0.4375 2.1641-1.2188 2.9453s-1.8398 1.2188-2.9453 1.2188h-33.336c-2.3008 0-4.1641-1.8633-4.1641-4.1641v-8.3359c0-4.418 1.7539-8.6602 4.8789-11.785s7.3672-4.8789 11.785-4.8789z" />
      <path d="m66.668 33.332c0 9.207-7.4648 16.668-16.668 16.668s-16.668-7.4609-16.668-16.668c0-9.2031 7.4648-16.664 16.668-16.664s16.668 7.4609 16.668 16.664" />
      <path d="m34.75 53.375c-2.6445-4.0117-6.8945-6.6914-11.656-7.3438-4.7617-0.64844-9.5742 0.78516-13.199 3.9414-3.6289 3.1523-5.7148 7.7227-5.7266 12.527v4.168c0 1.1055 0.4375 2.1641 1.2188 2.9453s1.8398 1.2188 2.9453 1.2188h16.668c0.0625-7.0977 3.7383-13.68 9.75-17.457z" />
      <path d="m29.707 37.957c-1.1953-4.9531-0.43359-10.176 2.125-14.582-2.5234-4.7852-7.8438-7.4023-13.176-6.4844s-9.4648 5.1641-10.246 10.52c-0.78125 5.3516 1.9727 10.602 6.8203 13 4.8477 2.4023 10.691 1.4141 14.477-2.4531z" />
      <path d="m79.168 45.832c-5.6133 0.011719-10.844 2.8477-13.918 7.543 6.0117 3.7773 9.6875 10.359 9.75 17.457h16.668c1.1055 0 2.1641-0.4375 2.9453-1.2188s1.2188-1.8398 1.2188-2.9453v-4.168c0-4.4219-1.7539-8.6602-4.8789-11.785s-7.3672-4.8828-11.785-4.8828z" />
      <path d="m79.168 16.668c-4.6172 0.019531-8.8477 2.582-11 6.6641 2.5586 4.4062 3.3203 9.6328 2.125 14.586 2.9336 2.9922 7.168 4.3164 11.285 3.5234 4.1133-0.78906 7.5586-3.5898 9.1758-7.457 1.6133-3.8672 1.1836-8.2852-1.1445-11.77-2.332-3.4805-6.2539-5.5664-10.441-5.5469z" />
    </svg>
  );
};
